<template>
    <div class="street-retail-section" v-if="streetReatailArr != null" id="menu-link-street">
        <div class="container">
            <sectionTitle :options="[{ title : streetReatailArr.street_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: streetReatailArr.street_quote_img, title : streetReatailArr.street_quote_title, desc: streetReatailArr.street_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : streetReatailArr.street_desc_left, desc_right: streetReatailArr.street_desc_right}]" class="section-desc-column-street"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: streetReatailArr.street_images_mobile}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <sectionImagesGrid :options="[{ cards: streetReatailArr.street_cards.slice(0, 3), grid_img : streetReatailArr.street_img}]" class="section-images-street"></sectionImagesGrid>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import sectionImagesGrid from '@/components/partials/section-images-grid.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'street-retail-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            streetReatailArr: 'loadStreetRetailArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            sectionImagesGrid,
            sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/street-retail/street-section.scss';
    @import '@/styles/components/street-retail/street-section-respond.scss';
</style>